import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql, StaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const SpeakersPage = () => (
  <Layout noBanner={true}>
    <Seo title="Speakers" />
    <StaticQuery
      query={graphql`
        query SpeakerQuery {
          allSpeakersJson {
            edges {
              node {
                id
                type
                name
                company
                title
                twitter
                github
                profile
                image {
                  childImageSharp {
                    gatsbyImageData(width: 600, height: 600)
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const speakers = data.allSpeakersJson.edges.map(edge => edge.node)
        const types = {"keynote": "基調講演", "special": "ゲストセッション", "cochairtalk": "Co-Chair トークセッション", "cfp": "公募セッション", "sponsor": "スポンサーセッション"}
        return (
          <section id="speakers" className="section-padding-top">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="section-title-header text-center">
                    <h1
                      className="section-title wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      Speakers
                    </h1>
                    <p className="wow fadeInDown" data-wow-delay="0.2s">
                      登壇者一覧
                    </p>
                  </div>
                </div>
              </div>
              {Object.keys(types).map((key, index) => (
                <div key={index}>
                  <div className="row wow fadeInDown" data-wow-delay="0.3s">
                    <h2 className="col-12 text-center">
                      {types[key]}
                    </h2>
                  </div>
                  <div className="row mb-5">
                    {speakers
                      .filter((speaker) => speaker.type === key)
                      .map((speaker, index) => {
                        const image = getImage(speaker.image)
                        return (
                          <div className="col-12 col-md-6 col-xl-4" foo="col-12 col-sm-6 col-lg-4 col-xl-3" key={index}>
                            <div className="team-item wow fadeInUp" data-wow-delay="0.2s">
                              <div className="team-img">
                                <GatsbyImage className="img-fluid" image={image} alt={speaker.name} />
                                <div className="team-overlay">
                                  <div className="overlay-social-icon text-center">
                                    <ul className="social-icons">
                                      {speaker.twitter !== '' && (
                                        <li><a href={'https://twitter.com/' + speaker.twitter} target="_blank" rel="noreferrer">
                                          <i className="lni lni-twitter-filled" aria-hidden="true"></i>
                                        </a></li>
                                      )}
                                      {speaker.github !== '' && (
                                        <li><a href={'https://github.com/' + speaker.github} target="_blank" rel="noreferrer">
                                          <i className="lni lni-github-original" aria-hidden="true"></i>
                                        </a></li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="info-text">
                                <h3>{speaker.name}</h3>
                                <p>{speaker.company} {speaker.title}</p>
                              </div>
                              <p className="profile m-2">{speaker.profile}</p>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )
      }}
    />
  </Layout>
)

export default SpeakersPage
